import { SVGProps } from 'react';

const ArrowLeftToLine = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      strokeWidth={1.5}
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M3 19V5m10 13-6-6 6-6m-6 6h14"
    />
  </svg>
);
export default ArrowLeftToLine;
